export const NAMESPACE = 'analytics';

export const SELECT_BY_VERSION = `${NAMESPACE}/SELECT_BY_VERSION`;
export const CLEAR_SELECT_BY_VERSION = `${NAMESPACE}/CLEAR_SELECT_BY_VERSION`;
